(function() {
  var loadOnCart = document.currentScript && document.currentScript.hasAttribute('data-load-on-cart');

  function insertAffirmScript(script, anchor) {
    if (!loadOnCart) {
      anchor.parentNode.insertBefore(script, anchor);
      return;
    }

    var pending = false;
    var drawer = document.getElementById('sidebar-cart');
    var observer;

    function load() {
      if (pending) return;
      pending = true;
      script.onload = function() {
        document.removeEventListener('click', onCartClick, true);
        if (observer) observer.disconnect();
        window.affirm.ui.ready(function() { window.affirm.ui.refresh(); });
      };
      script.onerror = function() {
        var source = script.src;
        script.remove();
        script = document.createElement('script');
        script.async = true;
        script.src = source;
        pending = false;
      };
      anchor.parentNode.insertBefore(script, anchor);
    }

    function onCartClick(event) {
      var cartLink = event.target.closest && event.target.closest('#HeaderCart');
      if (cartLink && cartLink.getAttribute('data-link-type') === 'drawer') load();
    }

    document.addEventListener('click', onCartClick, true);
    if (drawer) {
      observer = new MutationObserver(function() {
        if (drawer.classList.contains('show')) load();
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (drawer.classList.contains('show')) load();
    }
  }

_affirm_config = {
    public_api_key:  "OD1O1GQ3Q4RN1XS4",
    script:          "https://cdn1.affirm.com/js/v2/affirm.js"
  };
  (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];insertAffirmScript(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
  if (loadOnCart && typeof window.affirm.ui.refresh !== 'function') {
    var refreshPending = false;
    window.affirm.ui.refresh = function() {
      if (refreshPending) return;
      refreshPending = true;
      window.affirm.ui.ready(function() {
        refreshPending = false;
        window.affirm.ui.refresh();
      });
    };
  }
 // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
})();
